import {    CARGAR_ARTICULO, CARGAR_INGRESOBODEGA, CARGAR_EGRESOBODEGA,
            CARGAR_ARTICULOS, CARGAR_STOCKSARTICULO, CARGAR_RESERVASARTICULO } from '../actions/inventario/actionTypes';

const inventarioReducer = (state = {articulo_Sel: {}, ingresoBodega_Sel: {}, egresoBodega_Sel: {},
                                    articulos: []}, action) => {
    switch(action.type){
        case CARGAR_ARTICULO:        
            return { ...state, articulo_Sel: action.data };
        case CARGAR_STOCKSARTICULO:
            return { ...state, articulo_Sel: {...state.articulo_Sel, stocks: action.data }};
        case CARGAR_RESERVASARTICULO:
            return { ...state, articulo_Sel: {...state.articulo_Sel, reservas: action.data }};
        case CARGAR_INGRESOBODEGA:
            return { ...state, ingresoBodega_Sel: action.data };
        case CARGAR_EGRESOBODEGA:
            return { ...state, egresoBodega_Sel: action.data };
        case CARGAR_ARTICULOS:
            return { ...state, articulos: action.data };
        default:
            return state;
    }
};

export default inventarioReducer;